import { InjectionToken } from "@angular/core";

export const SESSION_RESET = "SESSION_RESET";
export const SESSION_REVIVE_RESET = "SESSION_REVIVE_RESET";
export const SESSION_TICK = "SESSION_TICK";
export const SESSION_FATAL_ERROR = "SESSION_FATAL_ERROR";
export const SESSION_WARNING_TIMEOUT_SET = "SESSION_WARNING_TIMEOUT_SET";


/**
 * @type {OpaqueToken} Angular DI provider token for session redux action factory implementations.
 */
export const SessionActionFactoryToken: InjectionToken<SessionActionFactory> =  new InjectionToken<SessionActionFactory>("session.action.factory");

/**
 * These redux actions are used mainly by the {@link SessionManagerService} to maintain the session state.
 */
export interface SessionActionFactory {
    /**
     * The session tick is an action that is dispatched in every second while the session is active and it should
     * refresh the remaining time counter of the session timeout, and revive needed counter as well.
     */
    sessionTick(): void;
    /**
     * This action is used to reset the timers in the session. It is dispatched mainly after back-end responses, though
     * it also used at session start to start the session time counter.
     * @param timeout The session timeout value in seconds.
     */
    sessionReset(timeout: number): void;
    /**
     * You can reset the session revive counter by dispathing this action. It is mainly used on every client side user
     * activity to ensure that during a long client side editing process the session is kept alive. The revive counter
     * is needed to avoid calling the back-end for session revive again-and-again in case of many continuous user
     * actions like typing for example. So, instead of calling the revive endpoint on every user action, we call the
     * back-end only if a certain amount of time had passed since the lat user activity.
     * @param timeout The delay in seconds after the last user activity to call the back-end for revive.
     */
    reviveReset(timeout: number): void;
    /**
     * This action is mainly used when a response with http 500 status is received from the back-end. It switches the
     * session state to an error state and the session handler will resolve this state most probably by initiating the
     * logout process.
     */
    fatalError(): void;

    setTimeoutWarningTime(warningTimeOut: number): void;
}
